<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">French Tourist Tax for {{huis.huis_code }} </p>
    <v-form ref="saveFrtt" v-model="saveFrttValid">
     
      <v-row no-gutters class="mx-2">  
       <v-col>
           <v-select v-model="huis.huis_fr_type" :items="huis_fr_typeKeuzes" item-value="type_code" item-text="type_oms" label="Acco Type"></v-select>
       </v-col>  
     </v-row>

      <v-row no-gutters class="mx-2">  
       <v-col>
           <v-select v-model="huis.mncp_code" :items="mncp_codeKeuzes" item-value="mncp_code" item-text="mncp_oms" label="Municipality"></v-select>
       </v-col>  
     </v-row>
     
     <v-row no-gutters class="mx-2">  
       <v-col>
           <v-select v-model="huis.huis_frtt_category" :items="huis_frtt_categoryKeuzes" item-value="category_code" item-text="category_oms" label="City tax category id"></v-select>
       </v-col>  
     </v-row>

    <v-row no-gutters class="mx-2">  
       <v-col>
           <v-select v-model="huis.huis_frtt_nature_category" :items="huis_frtt_nature_categoryKeuzes" item-value="category_nature_code" item-text="category_nature_oms" label="Nature category id"></v-select>
       </v-col>  
     </v-row>
     
     <v-row no-gutters class="mx-2">  
       <v-col>
           <v-text-field v-model="huis.huis_frtt_tarief" readonly label="Amount"></v-text-field>
       </v-col>  
     </v-row>

     <v-row no-gutters class="mx-2" v-if="huis.huis_frtt_tarief_max">  
       <v-col>
           <v-text-field v-model="huis.huis_frtt_tarief_max" readonly label="Max Amount"></v-text-field>
       </v-col>  
     </v-row>



    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="saveFrtt" :disabled="!saveFrttValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      saveFrttValid: false,
      huis_encrid: null,
      huis_frtt_categoryKeuzes: [],
      huis_frtt_nature_categoryKeuzes: [],
      mncp_codeKeuzes: [],
      huis_fr_typeKeuzes: [],
      huis: {}
    }
  },
  methods: {
    open(huis_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huis_encrid = huis_encrid;
      this.$axios
        .post("ares/json/ares/huis/frtt/getHuisToUpdFrtt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToUpdFrtt"
          },
          getHuisToUpdFrtt: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis = res.data.getHuisToUpdFrtt;
            res.data.getHuisToUpdFrtt.huis_frtt_categoryKeuzes.forEach(function(category) {
               deze.huis_frtt_categoryKeuzes.push(category); 
            });
            res.data.getHuisToUpdFrtt.huis_frtt_nature_categoryKeuzes.forEach(function(nature_category) {
               deze.huis_frtt_nature_categoryKeuzes.push(nature_category); 
            });
            res.data.getHuisToUpdFrtt.mncp_codeKeuzes.forEach(function(mncp) {
               deze.mncp_codeKeuzes.push(mncp); 
            });
            res.data.getHuisToUpdFrtt.huis_fr_typeKeuzes.forEach(function(type) {
               deze.huis_fr_typeKeuzes.push(type); 
            });
            deze.huis_encrid = huis_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveFrtt() { 
      this.$axios
        .post("ares/json/ares/huis/frtt/saveFrtt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveFrtt"
          },
          saveFrtt: {
            huis_encrid: this.huis.huis_encrid,
            mncp_code: this.huis.mncp_code,
            huis_fr_type: this.huis.huis_fr_type,
            huis_frtt_category: this.huis.huis_frtt_category,
            huis_frtt_nature_category: this.huis.huis_frtt_nature_category
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {          
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveFrtt.text,
              color: res.data.saveFrtt.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

